import axiosRequest, { request } from './restapi';

export const signInFormSubmit = (data: any) => {
  return request({
    method: 'post',
    url: 'users/login',
    data,
  });
};

export const forgotPassword = (data: any) => {
  return axiosRequest({
    method: 'post',
    url: 'users/forgot-password',
    data,
  });
};

export const resetPassword = (data: any) => {
  return axiosRequest({
    method: 'post',
    url: 'users/reset-password',
    data,
  });
};
